<template>
  <div class="activityList">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>参展证申请</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="header" style="margin-top: 10px;">
      <div style="padding-bottom:10px;color:red;font-size:16px;">特别提示：请您根据贵司展会现场实际到场的工作人员数量提交证件，避免浪费！</div>
      <div style="padding-bottom:10px;color:red;font-size:16px;">胸卡显示语言默认为中文，如需变更请点击修改进行选择。</div>
    </div>
    <div class="operas">
      <div class="tktNum">
        <!-- <span>可申请证件数量：<b style="color:red;">{{ticketNumObj.totalTicketNum}}</b>张，</span> -->
        <span style="padding-right: 20px;"><!-- 已提交 -->证件数量：<b style="color:green;">{{ticketNumObj.submittedTicketNum}}</b>张</span>
        <el-button type="primary" @click="addCard">新增</el-button>
        <el-button type="primary" @click="onSubmit('1')" :disabled="Dsave">暂存</el-button>
        <el-button type="primary" @click="onSubmit('')" :disabled="saveBtnStatue">提交</el-button>
      </div>
      <div class="">
        <!-- <el-button type="primary" @click="getListWarp">获取上届数据</el-button> -->
      </div>
      <!-- <el-button type="primary" @click="addCard" :style="buttonStyle">新增</el-button> -->
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="tktName"
        label="姓名">
      </el-table-column>
      <el-table-column
        prop="tktComName"
        label="公司名">
      </el-table-column>
      <!-- <el-table-column
        label="头像"
        width="160">
        <template slot-scope="scope">
          <img style="max-height:100px;" :src="scope.row.photo"/>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="tktPassportNo"
        label="证件号">
      </el-table-column>
      <el-table-column
        prop="tktRank"
        label="职位">
      </el-table-column>
      <el-table-column
        label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.tktSysState == '正常'">已提交</span>
          <span v-else>未提交</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="160"
        >
        <template slot-scope="scope"  v-if="scope.row.tktIfMakeCard !='1'">
          <el-button @click="editCard(scope.row)" type="text" size="small">修改</el-button>
          <el-button @click="deletCard(scope.row)" type="text" size="small" v-if="scope.row.tktIfTreat == false">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="往届数据" :visible.sync="oldDataDialog" width="60%" center >
      <div style="max-height:600px;overflow: hidden;overflow-y: auto;">
        <el-table
        align="center"
          :data="oldTableData"
          @selection-change="handleSelectionChange"

          style="width: 100%;">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
            <el-table-column
              prop="tktName"
              label="姓名">
            </el-table-column>
            <el-table-column
              prop="tktComName"
              label="公司名">
            </el-table-column>
            <el-table-column
              label="头像"
              width="160" align="center">
              <template slot-scope="scope">
                <img style="max-height:100px;max-width: 100px;text-align: center;" :src="scope.row.photo"/>
              </template>
            </el-table-column>
            <el-table-column
              prop="tktPassportNo"
              label="证件号码">
            </el-table-column>
            <el-table-column
              prop="tktRank"
              label="职位">
            </el-table-column>
            <el-table-column
              prop="tktMobile"
              label="手机号">
            </el-table-column>
          </el-table>
      </div>
        <!-- <div style="text-align:center;padding:10px 0">
            <el-pagination
            @current-change = 'pageChange'
            :page-size="10"
            layout="prev, pager, next"
            :total="total">
          </el-pagination>
        </div> -->
        <div style="text-align:center;padding-top:30px"><el-button type="primary" @click="saveHist">保存</el-button></div>
      </el-dialog>
  </div>
</template>
<script>
import api from '@/api'
import reg from '@/utils/regExp'
import tools from '../../utils/tools.js';
export default {
  name: 'Card',
  data() {
    return {
      tableData: [],
      ticketNumObj: {},
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      oldTableData:[],
      oldDataDialog:false,
      pageSize:'9999999',
      pageCurrent: '1',
      total:0,
      selectData:[],
      Dsave: true,
      saveBtnStatue: true
    }
  },
  mounted() {
    this.getTicket()
    this.getticketnum()
  },
  methods: {
    getListWarp(){
      this.oldDataDialog = true
      api.ticketnotthelist({
        exhId: this.ExhID,
        TktIfTheExhibition:'0',
        TktComName:this.userInfo.atrName,
        pageIndex: this.pageCurrent,
        pageSize: this.pageSize,
      }).then(res => {
        if (res.data.code === 200) {
          this.oldTableData = res.data.data.list
          this.total = res.data.data.total
        }
      })
    },
    pageChange(page){
      this.pageCurrent = page.toString()
      this.getListWarp()
    },
    handleSelectionChange(val){
      this.selectData = val
    },
    saveHist(){
      for(var i=0;i<this.selectData.length;i++){
        this.selectData[i].tktComName = this.userInfo.atrName
        this.selectData[i].tktType= ''
      }
      if(this.selectData.length>0){
        api.addtickets({
          exhId: this.ExhID,
          data:this.selectData
        }).then(res => {
          if (res.data.code === 200) {
            this.getTicket()
            this.getticketnum()
            this.$notify({
              title: '提示',
              message: res.data.msg,
              type: 'success'
            });
          } else if (res.data.code === 900) {
            // this.$toast.fail('登录超时！')
            this.$notify({
              title: '错误',
              message: res.data.msg,
              type: 'error'
            })
          }
          this.oldDataDialog = false
        })
      }else{
        this.$notify({
          title: '提示',
          message: '请选择！',
          type: 'warning'
        });
      }
    },
    getticketnum() {
      api.getticketnum().then(res => {
        if (res.data.code === 200) {
          this.ticketNumObj = res.data.data
          this.overlayshow = false
        }
      })
    },
    addCard() {
      if (this.ticketNumObj.totalTicketNum > this.ticketNumObj.submittedTicketNum) {
        this.$router.push({path: '/addCard', query: {type: 'add'}})
      } else {
        this.$notify({
          title: '错误',
          message: '证件数量已达上限',
          type: 'error'
        });
      }
    },
    deletCard(row) {
      this.$confirm('确定删除该证件？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        api.deleteticket({tktID: ''+row.tktID}).then(res => {
          if (res.data.code === 200) {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            });
            this.getTicket()
            this.getticketnum()
          }
        })
      }).catch(() => {});
    },
    resetForm() {
      this.ruleForm={
        tktName: '',
        tktComName: '',
        photo: '',
        tktIDCard: '',
        tktRank: ''
      }
    },
    getTicket() {
      api.ticketlist().then(res => {
        if (res.data.code === 200) {
          this.tableData = res.data.data.list
          this.Dsave = false
          this.saveBtnStatue = false
        }
      })
    },
    editCard(row, type) {
      this.$router.push({path: '/addCard', query: {type: 'edit', tktID: row.tktID}})
    },
    onSubmit(IsCache){
      api.SaveCACTicketSubmitStatus({
       IsCache: IsCache,
      }).then(res => {
        if (res.data.code === 200) {
          this.$notify({
            title: '提示',
            message: res.data.msg,
            type: 'success'
          });
          this.getTicket()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.activityList{
  .tktNum{
    span{
      font-size: 14px;
      b{
        font-size: 16px;
        padding: 0 10px;
      }
    }
  }
  .operas{
    text-align: right;
    padding: 20px 0;
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .fileParent {
    position: relative;
    img {
      position: absolute;
      width: 60px;
      height: 39px;
      left: 0;
      top: 0;
    }
  }
  .file {
    position: absolute;
    left: 0;
    opacity: 0;
  }
  .cardItem{
      -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      margin-bottom: 50px;
      padding: 20px;
      border-radius: 10px;
  }
  .cardItem .img{
      width:200px;
      height:200px;
      margin-right: 10px;
      text-align: center;
  }
  .cardItem .img img{
      max-width:100%;
      max-height:100%;
  }
  .rightBox{
    width: 65%;
    font-size:14px;
    position: relative;
    padding: 14px;
    p{
      padding-top:15px;
    }
    .bottom{
        padding-top: 20px;
    }
  }
  
  .mart30{
    padding-top:30px;
  }
  .blue{
    color:#409EFF
  }
  .cards{
    display: flex;
    flex-wrap: wrap;
    >li{
      padding: 0 20px;
      width: 50%
    }
  }
  @media screen and (max-width:540px){
    .cards>li{
      width: 100%;
      padding:0;
      .img{
        width:120px;
        height: auto;
      }
    }
    .rightBox{
      padding:0;
      font-size: 14px;
      >p{
        padding-top:10px;
      }
      .el-button{
        padding:8px 16px;
      }
    }
  }
}
</style>
